import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import Vuetify from 'vuetify/lib';
import '@/plugins/vuetify-styles.less';
// Importa un solo file Tailwind in base all'ambiente
if (process.env.NODE_ENV === 'production') {
  require('@/assets/css/tailwind.prod.css');
} else {
  require('@/assets/css/tailwind.css');
}
import VueCompositionAPI from '@vue/composition-api';

import VueCryptojs from 'vue-cryptojs';
import UUID from 'vue-uuid';
import { i18n } from '@/plugins/vuei18n';
import '@babel/polyfill';
import axios from 'axios';
// Translation
import VueI18n from 'vue-i18n';
import 'document-register-element/build/document-register-element';

import vueCustomElement from 'vue-custom-element';
import VueSocketio from 'vue-socket.io';
import VueMasonry from 'vue-masonry-css';
import io from 'socket.io-client';
import IdleVue from 'idle-vue';
import lodash from 'lodash';

console.log('UPDATE main.js test 16:16');

Vue.use(VueCompositionAPI);
Vue.use(VueCryptojs);

// Rende lodash disponibile globalmente come `_` per i componenti legacy
window._ = lodash;

window.skin = document
  .querySelector('#revenge-bet-console')
  .getAttribute('skin');
window.theme = document
  .querySelector('#revenge-bet-console')
  .getAttribute('theme');
window.icons = window.theme == 'dark' ? 'light' : 'dark';
window.icarus = false;
window.css = document.querySelector('#revenge-bet-console').getAttribute('css');
window.openlivesection = document
  .querySelector('#revenge-bet-console')
  .getAttribute('openlivesection')
  ? document
      .querySelector('#revenge-bet-console')
      .getAttribute('openlivesection')
  : false;
window.openTree = document
  .querySelector('#revenge-bet-console')
  .getAttribute('openTree')
  ? document.querySelector('#revenge-bet-console').getAttribute('openTree')
  : false;

window.sportId = document
  .querySelector('#revenge-bet-console')
  .getAttribute('sportId')
  ? document.querySelector('#revenge-bet-console').getAttribute('sportId')
  : null;
window.categoryId = document
  .querySelector('#revenge-bet-console')
  .getAttribute('categoryId')
  ? document.querySelector('#revenge-bet-console').getAttribute('categoryId')
  : null;
window.tournamentId = document
  .querySelector('#revenge-bet-console')
  .getAttribute('tournamentId')
  ? document.querySelector('#revenge-bet-console').getAttribute('tournamentId')
  : null;
window.eventId = document
  .querySelector('#revenge-bet-console')
  .getAttribute('eventId')
  ? document.querySelector('#revenge-bet-console').getAttribute('eventId')
  : null;
window.sportName = document
  .querySelector('#revenge-bet-console')
  .getAttribute('sportName')
  ? document.querySelector('#revenge-bet-console').getAttribute('sportName')
  : null;
window.tournamentName = document
  .querySelector('#revenge-bet-console')
  .getAttribute('tournamentName')
  ? document
      .querySelector('#revenge-bet-console')
      .getAttribute('tournamentName')
  : null;
window.eventName = document
  .querySelector('#revenge-bet-console')
  .getAttribute('eventName')
  ? document.querySelector('#revenge-bet-console').getAttribute('eventName')
  : null;
window.forceMobileView = document
  .querySelector('#revenge-bet-console')
  .getAttribute('forceMobileView')
  ? document
      .querySelector('#revenge-bet-console')
      .getAttribute('forceMobileView')
  : false;
window.oddsType = document
  .querySelector('#revenge-bet-console')
  .getAttribute('oddsType')
  ? document.querySelector('#revenge-bet-console').getAttribute('oddsType')
  : 'american';

const lang = document.querySelector('#revenge-bet-console').getAttribute('lang')
  ? document.querySelector('#revenge-bet-console').getAttribute('lang')
  : process.env.VUE_APP_FALLBACK_LOCALE;
const geoPlay = document
  .querySelector('#revenge-bet-console')
  .getAttribute('play')
  ? document.querySelector('#revenge-bet-console').getAttribute('play') ===
    'true'
    ? true
    : false
  : true;
const urlStyle =
  process.env.VUE_APP_URL_API + '/themes/get-style/' + window.skin;

if (process.env.NODE_ENV == 'local' && window.css && window.css != '') {
  const urlCss = 'http://localhost:8082/themes/skin/' + window.css + '.css';
  addCss(urlCss);
}

if (process.env.NODE_ENV == 'development' && window.css && window.css != '') {
  const urlCss =
    process.env.VUE_APP_REVENGE_DEV + '/themes/skin/' + window.css + '.css';
  addCss(urlCss);
}

if (process.env.NODE_ENV == 'production' && window.css && window.css != '') {
  const urlCss =
    process.env.VUE_APP_URL_SIRPLAY_CLOUDFRONT +
    '/themes/skin/' +
    window.css +
    '.css';
  addCss(urlCss);
}

if (window.forceMobileView === true || window.forceMobileView === 'true') {
  document.body.classList.add('mobile-view');
}

const themesColor = {};

const optsVuetify = {
  lang: {
    current: lang,
    silentFallbackWarn: true
  },
  theme: {
    options: {
      customProperties: true
    },
    dark: theme == 'light' ? false : true,
    themes: {}
  }
};

Vue.use(Vuetify);
Vue.use(UUID);
Vue.filter('round_digits', function (value, digits) {
  if (value) {
    return value.toFixed(digits);
  } else {
    return (0.0).toFixed(digits);
  }
});

Vue.filter('truncate', function (value, size, truncate = '...') {
  if (!value) return '';
  value = value.toString();

  if (value.length <= size) {
    return value;
  }
  return value.substr(0, size) + truncate;
});

Vue.filter('capitalize', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('odds_type_filter', function (value) {
  const type = store.getters['odds/getOddsType'];

  if (type == 'american') {
    let oddAmerican;

    const oddInt = value;
    if (oddInt > 2) {
      oddAmerican = (oddInt - 1) * 100;
    } else {
      oddAmerican = Math.round(-100 / (value - 1));
    }

    const oddAmericanFormat = Intl.NumberFormat('en-US', {
      signDisplay: 'exceptZero'
    }).format(oddAmerican);

    const newOddAmerican = oddAmericanFormat.replace(/\,/g, '');

    return newOddAmerican;
  } else {
    return value;
  }
});

Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(vueCustomElement);
Vue.use(VueMasonry);

const eventsHub = new Vue();
const options = {
  eventEmitter: eventsHub,
  idleTime: 420000
  //idleTime: 20000
};
Vue.use(IdleVue, options);

const platform_id = document
  .querySelector('#revenge-bet-console')
  .getAttribute('platform');
const user_id = document
  .querySelector('#revenge-bet-console')
  .getAttribute('user_id');
const icarus = document
  .querySelector('#revenge-bet-console')
  .getAttribute('icarus');

const url = process.env.VUE_APP_URL_API + '/auth/livetoken';
const urlrefresh = process.env.VUE_APP_URL_API + '/auth/tokenguest';

if (!localStorage.getItem('token')) {
  axios
    .post(url, { platform: platform_id })
    .then(({ data }) => {
      console.log('UPDATE main.js Data token', data);
      console.log('update Platform id', platform_id);
      localStorage.setItem('token', data.accessToken);
      localStorage.setItem('refresh', data.refreshToken);
      localStorage.setItem('expired', data.expired);
      localStorage.setItem('scope', data.scope);
      initAppVue(data.accessToken);
    })
    .catch(error => {
      console.log('token not available');
      console.log(error);
      initAppVue('not_auth');
    });
} else {
  const datenow = new Date().getTime();
  const dateexpired = localStorage.getItem('expired');
  const date1 = new Date(datenow);
  const date2 = new Date(dateexpired * 1000);
  const diffTime = date2 - date1;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  if (diffTime < 0) {
    axios
      .post(urlrefresh, { token: localStorage.getItem('refresh') })
      .then(({ data }) => {
        localStorage.setItem('token', data.accessToken);
        localStorage.setItem('expired', data.expired);
      })
      .then(success => {
        initAppVue(localStorage.getItem('token'));
      })
      .catch(error => {
        console.log('error in urlrefresh');
        console.log(error);
        initAppVue('not_auth');
      });
  } else {
    initAppVue(localStorage.getItem('token'));
  }
}

function addCss(fileName) {
  const head = document.head;
  const link = document.createElement('link');

  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.href = fileName;

  head.appendChild(link);
}

async function initAppVue(token) {
  if (token != 'not_auth') {
    // Set Token
    store.dispatch('settings/setToken', token);
    console.log('mainjs test token 17:17', token);
    try {
      const { data } = await axios.get(
        process.env.VUE_APP_URL_API + `/ui/ui-components-config/${platform_id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      store.dispatch('uiConfig/setUIConfig', data);
    } catch (err) {
      console.error(err);
      router.push('/404V2');
    }

    // Get Rules
    const url = process.env.VUE_APP_URL_API + '/skins/get-my-rules';
    axios
      .post(url, {}, { headers: { Authorization: `Bearer ${token}` } })
      .then(async ({ data }) => {
        // Set Manager Rules
        store.commit('rules/SET_RULES_MANAGER', data.data[0].rules);
        store.commit('rules/SET_RULES_SKIN', data.data[1].rules);
        store.commit('rules/SET_RULES_DISABLED', data.data[1].disables);
        store.commit(
          'rules/SET_TEMPLATE_MANAGER',
          data.data[0].templates ? data.data[0].templates : []
        );
        store.commit(
          'rules/SET_TEMPLATE_SKIN',
          data.data[1].templates ? data.data[1].templates : []
        );
        store.commit('cart/SET_CART_SETTINGS', data.data[1].rules);
        store.commit('settings/SET_PLATFORM_SETTINGS', data.data[1].settings);
        store.commit('settings/SET_RESULTS', data.data[1].results);
        store.commit('settings/SET_SHOW_QUICKBET', data.data[1].showquickbet); // showquickbet === transfer to quick bet
        store.commit('settings/SET_NEXT_EVENT', data.data[1].nextevent);
        store.commit('settings/SET_EVENT_DAY', data.data[1].eventday);
        store.commit('settings/SET_CASH_OUT', data.data[1].cashout);
        store.commit('settings/SET_CASH_OUT_LIVE', data.data[1].cashoutlive);
        store.commit('settings/SET_ICON', data.data[1].icon);
        store.commit('settings/SET_VOID_AS_LOSE', data.data[1].voidAsLose);
        store.commit(
          'settings/SET_STREAM_LIVE',
          data.data[1].settings.stream_live
        );

        for (const rule of data.data[1].rules) {
          if (rule.type == 'cart') {
            if (rule.detail.shortCode != null) {
              store.commit('settings/SET_SHORT_CODE', rule.detail.shortCode);
            } else {
              store.commit('settings/SET_SHORT_CODE', false);
            }
          }
        }

        if (data.data[1].settings.typeOdds !== undefined) {
          if (data.data[1].settings.typeOdds == true) {
            store.commit('odds/SET_ODDS_TYPE', 'american');
          } else {
            store.commit('odds/SET_ODDS_TYPE', 'decimal');
          }
        }

        if (data.data[1].gameConsole != null) {
          store.commit('settings/SET_GAME_CONSOLE', data.data[1].gameConsole);
        } else {
          store.commit('settings/SET_GAME_CONSOLE', 'default');
        }

        if (data.data[1].featuredTournamentAutoLoad != null) {
          store.commit(
            'settings/SET_FEATURED_TOURNAMENT_AUTOLOAD',
            data.data[1].featuredTournamentAutoLoad
          );
        }
        if (data.data[1].featuredTournamentWidget != null) {
          store.commit(
            'settings/SET_FEATURED_TOURNAMENT_WIDGET',
            data.data[1].featuredTournamentWidget
          );
        }

        if (data.data[1].enableClearCartAtPlaceBet != null) {
          store.commit(
            'settings/SET_ENABLE_CLEAR_CART_AT_PLACE_BET',
            data.data[1].enableClearCartAtPlaceBet
          );
        }

        if (data.data[1].enabledTaxOnWon != null) {
          store.commit(
            'settings/SET_ENABLE_TAX_ON_WON',
            data.data[1].enabledTaxOnWon
          );
        } else {
          store.commit('settings/SET_ENABLE_TAX_ON_WON', false);
        }

        if (data.data[1].percentageTaxValueOnWon != null) {
          store.commit(
            'settings/SET_PERCENTAGE_TAX_VALUE_ON_WON',
            data.data[1].percentageTaxValueOnWon
          );
        } else {
          store.commit('settings/SET_PERCENTAGE_TAX_VALUE_ON_WON', 0);
        }

        if (data.data[1].enableAgencyCanPlayForUser != null) {
          store.commit(
            'settings/SET_AGENCY_CAN_PLAY_FOR_USER',
            data.data[1].enableAgencyCanPlayForUser
          );
        } else {
          store.commit('settings/SET_AGENCY_CAN_PLAY_FOR_USER', false);
        }

        if (data.data[1].enableMobileBottomToolbar != null) {
          store.commit(
            'settings/SET_ENABLE_MOBILE_BOTTOM_TOOLBAR',
            data.data[1].enableMobileBottomToolbar
          );
        } else {
          store.commit('settings/SET_ENABLE_MOBILE_BOTTOM_TOOLBAR', false);
        }

        if (data.data[1].explodeMarketOnMobileDevice != null) {
          store.commit(
            'settings/SET_EXPLODE_MARKETS_ON_MOBILE_DEVICE',
            data.data[1].explodeMarketOnMobileDevice
          );
        } else {
          store.commit('settings/SET_EXPLODE_MARKETS_ON_MOBILE_DEVICE', false);
        }

        if (data.data[1].disableIdleUICheck != null) {
          store.commit(
            'settings/SET_DISABLE_UI_CHECK',
            data.data[1].disableIdleUICheck
          );
        } else {
          store.commit('settings/SET_DISABLE_UI_CHECK', false);
        }

        let proxyUrl = null;

        if (data.data[1].proxyUrl != null && data.data[1].proxyUrl != '') {
          proxyUrl = data.data[1].proxyUrl;
          store.dispatch('settings/setProxyUrl', proxyUrl);
        }

        let disableSessionCheck = false;

        if (data.data[1].disableSessionCheck != null) {
          disableSessionCheck = data.data[1].disableSessionCheck;
        }

        if (data.data[1].showMultiplicityLegendMobile != null) {
          store.commit(
            'settings/SET_SHOW_MULTIPLICITY_LEGEND_ON_MOBILE_DEVICE',
            data.data[1].showMultiplicityLegendMobile
          );
        } else {
          store.commit(
            'settings/SET_SHOW_MULTIPLICITY_LEGEND_ON_MOBILE_DEVICE',
            false
          );
        }

        if (data.data[1].enableTreeWithPlayerOutcomes != null) {
          store.commit(
            'settings/SET_ENABLE_TREE_WITH_PLAYER_OUTCOMES',
            data.data[1].enableTreeWithPlayerOutcomes
          );
        } else {
          store.commit('settings/SET_ENABLE_TREE_WITH_PLAYER_OUTCOMES', false);
        }

        if (data.data[1].quickbet != null) {
          store.commit('settings/SET_QUICK_BET_ENABLED', data.data[1].quickbet);
        }

        if (data.data[1].allowIntegralLiveBet != null) {
          store.commit(
            'settings/SET_ALLOW_INTEGRAL_LIVE_BET',
            data.data[1].allowIntegralLiveBet
          );
        }

        if (data.data[1].useCashout != null) {
          store.commit('settings/SET_CASH_OUT_V2', data.data[1].useCashout);
        } else {
          store.commit('settings/SET_CASH_OUT_V2', false);
        }

        if (data.data[1].cashoutApiPollIntervalSec != null) {
          store.commit(
            'settings/SET_CASHOUT_API_POLL_INTERVAL_SEC',
            data.data[1].cashoutApiPollIntervalSec
          );
        } else {
          store.commit('settings/SET_CASHOUT_API_POLL_INTERVAL_SEC', 60);
        }

        store.dispatch('user/setCanPlay', geoPlay);

        // todo in future will be deprecate, all will call proxy
        if (proxyUrl == null) {
          axios
            .get(
              data.data[1].settings.sircms_endpoint + 'bookie/sircms/banners',
              {
                headers: {
                  'content-type': 'application/json'
                }
              }
            )
            .then(result => {
              store.commit('settings/SET_BANNERS', result.data.success);
            });
        } else {
          axios
            .get(proxyUrl + '/sircms/banners', {
              headers: {
                'content-type': 'application/json'
              }
            })
            .then(result => {
              store.commit('settings/SET_BANNERS', result.data.success);
            });
        }

        const customerId = data.data[1].settings.skin_id;
        store.commit('settings/SET_CUSTOMER_ID', customerId);

        const nodeJsSocket = true;

        if (process.env.VUE_APP_ENABLE_SOCKET == '1') {
          if (nodeJsSocket == true) {
            const socketInstance = io(process.env.VUE_APP_URL_SOCKET, {
              transports: ['websocket'],
              upgrade: false
            });

            const socket = new VueSocketio({
              debug: false,
              secure: true,
              connection: socketInstance, //options object is Optional
              vuex: {
                store,
                actionPrefix: 'SOCKET_',
                mutationPrefix: 'SOCKET_'
              }
            });
            Vue.use(socket);
            store.commit('socket/setSocket', socket.io);
            store.dispatch('socket/socket_login', { platform_id: platform_id });

            if (user_id != undefined && +user_id != 0) {
              // console.log('[DEBUG] USER ID: ')
              // console.log(user_id);
              store.dispatch(
                'socket/socket_login_generic',
                platform_id + '-' + user_id
              );
            }
          }
        }

        if (user_id != undefined && +user_id != 0) {
          if (
            process.env.NODE_ENV == 'production' &&
            disableSessionCheck === false
          ) {
            const url_auth_session = '/commons/api.jsp?c=user';
            const checksession = await axios.get(url_auth_session, {
              headers: {
                contentType: 'application/json',
                Accept: 'application/json'
              }
            });

            if (
              !checksession.data.result ||
              checksession.data.data.playerId != user_id
            ) {
              console.log('no checksession');
              router.push('/404');
            }
          }

          const url_auth = process.env.VUE_APP_URL_API + '/auth/bookietoken';
          await axios
            .post(
              url_auth,
              {
                platform: platform_id,
                userid: +user_id
              },
              { headers: { Authorization: `Bearer ${token}` } }
            )
            .then(async ({ data }) => {
              //check data login
              localStorage.setItem('logged_token', data.accessToken);
              localStorage.setItem('logged_refresh', data.refreshToken);
              localStorage.setItem('logged_expired', data.expired);
              localStorage.setItem('logged_scope', data.scope);
              localStorage.setItem('logged_type', data.type);
              localStorage.setItem('logged_cashier', data.cashier);

              store.dispatch('user/setUserData', {
                id: data.id,
                login: data.login,
                token: data.accessToken,
                type: data.type,
                cashier: data.cashier,
                language: data.language,
                timezone: data.timezone,
                agencyLogin: data.agencyLogin,
                operatorLogin: data.operatorLogin,
                agencyNet: data.agencyNet,
                operatorNet: data.operatorNet,
                profileType: data.profileType != null ? data.profileType : null
              });

              /* check user type */
              const showFirstQuickBet =
                store.getters['settings/getShowQuickbet'];
              const isCashier = store.getters['user/getCashier'];
              const typeOfUser = store.getters['user/getType'];

              if (showFirstQuickBet && (isCashier || typeOfUser == 4)) {
                store.dispatch('odds/setLiveMode', { mode: 'qBet' });
                store.dispatch('tree/setStatusQbet', true);
                store.dispatch('tree/setStatusPrint', false);
              }
            })
            .catch(error => {
              router.push('/404V2');
            });
        } else {
          localStorage.removeItem('logged_token');
          localStorage.removeItem('logged_refresh');
          localStorage.removeItem('logged_expired');
          localStorage.removeItem('logged_scope');
          await store.dispatch('user/removeUserData');
        }

        if (icarus != undefined) {
          window.icarus = true;
        }

        let electron = false;

        if (
          typeof window !== 'undefined' &&
          typeof window.process === 'object' &&
          window.process.type === 'renderer'
        ) {
          electron = true;
        } else if (
          typeof process !== 'undefined' &&
          typeof process.versions === 'object' &&
          !!process.versions.electron
        ) {
          electron = true;
        } else if (
          typeof navigator === 'object' &&
          typeof navigator.userAgent === 'string' &&
          navigator.userAgent.indexOf('Electron') >= 0
        ) {
          electron = true;
        }

        //force for agency e cashier
        const isCashier = store.getters['user/getCashier'];
        const typeOfUser = store.getters['user/getType'];

        if (isCashier || typeOfUser == 4) {
          electron = true;
        }

        store.dispatch('settings/setElectron', electron);

        if (process.env.NODE_ENV == 'production') {
          Vue.config.silent = true;
          Vue.config.devtools = false;
          Vue.config.productionTip = false;
        } else if (process.env.NODE_ENV == 'development') {
          Vue.config.silent = true;
          Vue.config.devtools = false;
          Vue.config.productionTip = false;
        } else if (process.env.NODE_ENV == 'local') {
          Vue.config.silent = true;
          Vue.config.devtools = true;
          Vue.config.productionTip = false;
        }

        // const cssFile = await fetchPlatformCss(platform_id);
        // addCss(cssFile);

        new Vue({
          router,
          i18n,
          axios,
          store,
          vuetify: new Vuetify(optsVuetify),
          render: h => h(App)
        }).$mount('#revenge-bet-console');
      })
      .catch(error => {
        console.log(error);
        router.push('/404V3');
      });
  } else {
    console.log('pushing 404');
    router.push('/404');
  }
}

async function fetchPlatformCss(platformId) {
  try {
    const res = await axios.get(
      process.env.VUE_APP_URL_API + '/api/platform-css',
      { params: { platform_id: platformId } }
    );
    return res.data && res.data.cssFile ? res.data.cssFile : 'style.css';
  } catch (err) {
    return 'style.css';
  }
}

function addCssPersonalized(cssFile) {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = '/themes/skin/' + cssFile;
  link.setAttribute('data-custom-css', 'true');
  document.head.appendChild(link);
}
